import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, type TrackingPayload } from '@/utils/amplitude/analytics/core.types';

type SearchByImageResultsLoadedPayload = TrackingPayload & {
    numberOfSearchResults: number;
};

// Fired from the submitImageSearch thunk (not a component) once results resolve, so there is no hook sibling here.
export const trackSearchByImageResultsLoadedAnalytics = (payload: SearchByImageResultsLoadedPayload) => {
    track(TrackingEvents.SearchByImage.ResultsLoaded, payload);
};
